import type { InjectionKey } from 'vue';
import type { createListingDetailsStore } from './useListingDetailsStore';
import type { createListingFaqsStore } from './useListingFaqsStore';
import type { createListingCustomerStoriesStore } from './useListingCustomerStoriesStore';
import type { createListingOfferedServicesStore } from './useListingOfferedServicesStore';
import type { createListingPackagedServicesStore } from './useListingPackagedServicesStore';

export const ListingDetailsStoreKey: InjectionKey<ReturnType<typeof createListingDetailsStore>> = Symbol('ListingDetailsStore');
export const ListingFaqsStoreKey: InjectionKey<ReturnType<typeof createListingFaqsStore>> = Symbol('ListingFaqsStore');
export const ListingCustomerStoriesStoreKey: InjectionKey<ReturnType<typeof createListingCustomerStoriesStore>> = Symbol('ListingCustomerStoriesStore');
export const ListingOfferedServicesStoreKey: InjectionKey<ReturnType<typeof createListingOfferedServicesStore>> = Symbol('ListingOfferedServicesStore');
export const ListingPackagedServicesStoreKey: InjectionKey<ReturnType<typeof createListingPackagedServicesStore>> = Symbol('ListingPackagedServicesStore');

